import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';


@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    CollapseModule.forRoot(),
    BsDropdownModule,
    CollapseModule
  ],
  providers: [],
  exports: [
    HeaderComponent
  ],
  entryComponents: [HeaderComponent]

})
export class HeaderModule { }
